module.exports = __webpack_public_path__ + "img/visitorIcon.ffb29340.svg";